package org.lennycodes.hldi.pages
import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.style.breakpoint.ResponsiveValues

import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.lennycodes.hldi.components.ContactForm
import org.lennycodes.hldi.constants.HLDITheme
import org.lennycodes.hldi.layouts.MainLayout
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaFacebook
import com.varabyte.kobweb.silk.components.icons.fa.FaInstagram
import com.varabyte.kobweb.silk.components.icons.fa.FaWhatsapp
import com.varabyte.kobweb.silk.components.icons.fa.FaX
import com.varabyte.kobweb.silk.components.icons.fa.FaXTwitter
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.attributes.ATarget
import org.jetbrains.compose.web.attributes.target
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.JustifyContent
import org.lennycodes.hldi.components.ContactInfoCard
import org.lennycodes.hldi.constants.RNInfo
import org.lennycodes.hldi.styles.AboutHeroSectionStyle
import org.lennycodes.hldi.styles.AboutHeroTextStyle
import org.lennycodes.hldi.styles.AboutHeroTitleStyle
import org.lennycodes.hldi.styles.MapStyle
import org.lennycodes.hldi.styles.SectionWaveSvg
import org.lennycodes.hldi.styles.SocialIconButtonStyle
import org.lennycodes.hldi.styles.SocialLinksRowStyle
import org.lennycodes.hldi.styles.contactHeroStyle
import org.lennycodes.hldi.styles.contactHeroTitleStyle
import org.lennycodes.hldi.styles.contactInfoCardStyle
import org.lennycodes.hldi.styles.socialLinkStyle

@Composable
@Page("/contact")
fun ContactPage() {
    MainLayout {
        // Hero
        Section(
            attrs = Modifier.padding(50.px, 20.px).then( AboutHeroSectionStyle.toModifier())
                .toAttrs()
        ) {
            H1(attrs = AboutHeroTitleStyle.toAttrs()) {
                Text("Contact Us")
            }
            P(
                attrs = AboutHeroTextStyle.toAttrs {
                    style { maxWidth(700.px) } // wider than the shared 600px default for this section's longer copy
                }
            ) {
                Text("Get in touch with us. We'd love to hear from you.")
            }
            SectionWaveSvg()
        }
        Section {
            SimpleGrid(
                numColumns = ResponsiveValues(
                    base = 1, // mobile: stacked
                    md = 2,
                    sm = 2,
                    lg = 2,
                    xl = 2,
                    xxl = 2    // form + info side by side
                ),
                modifier = Modifier
                    .margin(top = 75.px)
                    .gap(48.px)
            ) {
                Div(
                    attrs = Modifier.padding(left = 32.px).toAttrs()
                ) {
                    H2(/* ... unchanged ... */) { Text("Send Us a Message") }
                    ContactForm()
                }

                Div (
                    attrs = Modifier.padding(right = 32.px).toAttrs()
                ){
                    H2(/* ... unchanged ... */) { Text("Contact Information") }

                    Div(
                        attrs = {
                            style {
                                display(DisplayStyle.Flex)
                                flexDirection(FlexDirection.Column)
                                gap(24.px)
                            }
                        }
                    ) {
                        ContactInfoCard(icon = "📞", title = "Phone") {
                            P(attrs = { style { color(HLDITheme.Colors.mediumGray) } }) { Text(RNInfo.phone[0]) }
                            P(attrs = { style { color(HLDITheme.Colors.mediumGray) } }) { Text(RNInfo.phone[1]) }
                        }
                        ContactInfoCard(icon = "📠", title = "Fax") {
                            P(attrs = { style { color(HLDITheme.Colors.mediumGray) } }) { Text(RNInfo.fax) }
                        }
                        ContactInfoCard(icon = "✉️", title = "Email") {
                            P(attrs = { style { color(HLDITheme.Colors.mediumGray) } }) { Text(RNInfo.email) }
                        }

                        ContactInfoCard(icon = "📍", title = "Address") {
                            P(attrs = { style { color(HLDITheme.Colors.mediumGray) } }) {
                                Text(RNInfo.address)
                            }
                        }

                        Div(attrs = Modifier.padding(24.px)
                            .then(contactInfoCardStyle.toModifier()).toAttrs()) {
                            H3(
                                attrs = { style { fontSize(18.px); color(HLDITheme.Colors.text); marginBottom(16.px) } }
                            ) { Text("Follow Us") }

                            Div(attrs = SocialLinksRowStyle.toAttrs()) {
                                listOf(
                                    @Composable { modifier: Modifier -> FaInstagram(modifier = modifier) } to "https://www.instagram.com/rn_hldi_tz/",
                                    @Composable { modifier: Modifier -> FaFacebook(modifier = modifier) } to "https://web.facebook.com/profile.php?id=61592315222621",
                                ).forEach { (iconContent, url) ->
                                    A(
                                        href = url,
                                        attrs = SocialIconButtonStyle.toAttrs {
                                            target(ATarget.Blank)
                                        }
                                    ) {
                                        iconContent(Modifier)
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        // Map Section
        Section(
            attrs = Modifier
                .backgroundColor(HLDITheme.Colors.white)
                .padding(topBottom = 48.px, leftRight = 20.px)
                .toAttrs()
        ) {
            Div(
                attrs = {
                    style {
                        display(DisplayStyle.Flex)
                        justifyContent(JustifyContent.Center)
                    }
                }
            ) {
                Iframe(
                    attrs = Modifier.then(MapStyle.toModifier()).toAttrs {

                        attr(
                            "src",
                            "https://www.google.com/maps/embed/v1/place?key=AIzaSyCCjVU7kxLRxwLwdVtTv0jyEpudIeY-YOA&q=HUMAN LIFE DEFENCE DEPARTMENT – RULENGE NGARA CATHOLIC DIOCESE\n" + "Mission, Biharamulo, Kagera, Tanzania"
                        )
                        attr("allowfullscreen", "true")
                        attr("loading", "lazy")
                        attr("referrerpolicy", "no-referrer-when-downgrade")
                    }
                )
            }
        }
    }
}